import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpTrialAccountRequestFilters, TrialAccountRequest } from '../models';

@Injectable()
export class TrialAccountsService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject('apiBaseUrl') private apiBaseUrl: string,
  ) {}

  public getTrialAccountRequests(
    httpFilters?: HttpTrialAccountRequestFilters[],
  ): Observable<{ items: TrialAccountRequest[] }> {
    let params: HttpParams;
    if (httpFilters && httpFilters.length) {
      params = new HttpParams({
        fromObject: { 'status[]': httpFilters as string[] },
      });
    }

    return params
      ? this.httpClient.get<{ items: TrialAccountRequest[] }>(
          `${this.apiBaseUrl}trial-requests`,
          { params },
        )
      : this.httpClient.get<{ items: TrialAccountRequest[] }>(
          `${this.apiBaseUrl}trial-requests`,
        );
  }

  public approveTrialRequest(
    accountId: string,
    requestId: string,
  ): Observable<TrialAccountRequest> {
    return this.httpClient.patch<TrialAccountRequest>(
      `${this.apiBaseUrl}trial-requests/${requestId}/approve`,
      { accountId },
    );
  }

  public declineTrialRequest(id: string): Observable<TrialAccountRequest> {
    return this.httpClient.patch<TrialAccountRequest>(
      `${this.apiBaseUrl}trial-requests/${id}/decline`,
      {},
    );
  }
}
